import React, { useState } from "react";
import { Check, Circle, RotateCcw } from "lucide-react";
import { euro, formatDate } from "../../lib/practiceApi";
import { EconomicStageDialog } from "./EconomicStageDialog";
import { LABELS, STAGES } from "./stageForm";
import "./stages.css";

export const EconomicStages = ({ practice, onChanged = () => {} }) => {
  const current = practice.economic_stage_index ?? 0;
  const [dialog, setDialog] = useState("");
  const [flash, setFlash] = useState("");
  const open = stage => { setFlash(""); setDialog(stage); };
  return <section className="practice-section stage-track" data-testid="economic-stages">
    <div className="practice-section-heading">
      <h2>Avanzamento economico</h2>
      <span data-testid="stage-hint">{practice.economic_stage_hint}{practice.economic_outstanding ? ` · ${euro(practice.economic_outstanding)} ancora da incassare` : ""}</span>
    </div>
    <div className="stage-mode">
      <span data-testid="economic-stage-mode">{practice.economic_stage_manual ? "Stato manuale" : "Avanzamento automatico"} · <strong>{practice.economic_stage_label}</strong></span>
      {practice.economic_stage_override && <button className="ghost" data-testid="economic-stage-restore" onClick={() => open("automatico")}><RotateCcw size={13} />Ripristina automatico</button>}
    </div>
    <ol className="stage-list">
      {STAGES.map(([key, label], index) => {
        const settled = key === "saldata" && practice.economic_stage === "saldata";
        const state = index < current || settled ? "done" : index === current ? "now" : "todo";
        const event = practice.economic_stage_events?.[key];
        return <li key={key} className={`stage-step ${state} actionable`}>
          <button type="button" data-testid={`stage-${key}`} onClick={() => open(key)} aria-current={index === current ? "step" : undefined}
            title={`${label}${event?.date ? ` · ${formatDate(event.date)}` : ""} · Conferma o aggiorna il passaggio`}>
            <span className="stage-dot">{state === "done" ? <Check size={12} /> : <Circle size={8} />}</span>
            <span className="stage-label">{label}</span>
          </button>
        </li>;
      })}
    </ol>
    {practice.invoiced && <p className="muted stage-invoice-note" data-testid="stage-invoice-note">
      Fattura {practice.invoice_number ? `n° ${practice.invoice_number}` : "registrata"}{practice.invoice_date ? ` del ${formatDate(practice.invoice_date)}` : ""}
    </p>}
    {flash && <p role="status" className="stage-success" data-testid="economic-stage-success">{flash}</p>}
    {dialog && <EconomicStageDialog key={`${practice.id}-${dialog}`} practice={practice} stage={dialog} onClose={() => setDialog("")}
      onSaved={result => { setFlash(`${LABELS[dialog] || "Avanzamento automatico"} confermato · cronoprogramma aggiornato`); onChanged(result); }} />}
  </section>;
};